var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 634.48 639.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #780026;\n      }\n      .skin-dark {\n        fill: #d8aa88;\n      }\n      .skin {\n        fill: #ecbc94;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.72,640H58.37C83.42,514.15,190.61,419.59,319.05,419.59S554.67,514.15,579.72,640Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin-dark",
    d: "M242,384H392a0,0,0,0,1,0,0v83.59A37.41,37.41,0,0,1,354.54,505H279.37A37.41,37.41,0,0,1,242,467.59V384A0,0,0,0,1,242,384Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 317.46,
    cy: 214,
    rx: 274.5,
    ry: 214
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 591.46,
    cy: 242,
    rx: 68,
    ry: 39.5,
    transform: "translate(179.16 730.26) rotate(-72.07)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 43.03,
    cy: 242.07,
    rx: 39.5,
    ry: 68,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -72.42, 24.99)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset12);
export default __webpack_public_path__ + "static/media/Asset 12.7b85338a.svg";
export { ForwardRef as ReactComponent };